import { TextField } from "@mui/material";
import React from "react";

export default function FormTextField({
  name,
  size = "medium",
  register,
  label,
  defaultValue,
  errors,
  inputProp,
  maxLen,
  required,
  testId,
  ...rest
}) {
    const inputPropsValue = {
    ...(inputProp ?? { maxLength: maxLen ?? 120 }),
    ...(testId ? { "data-testid": testId } : {}),
  };
  return (
    <TextField
      fullWidth
      inputProps={inputPropsValue}
      label={label}
      defaultValue={defaultValue}
      key={name}
      {...register(name, required)}
      error={!!errors[name]}
      helperText={errors[name]?.message}
      {...rest}
      size={size}
    />
  );
}
